module.exports = __webpack_public_path__ + "static/media/layer-plus.af762064.svg";